module.exports = __webpack_public_path__ + "img/logo.c6dd146a.svg";